import { createContext } from "react";
import { ArticleSectionStatus } from "../../../../__generated__/gql/graphql";

const ArticleContext = createContext<{
  sections: {
    id: string;
    additionalPrompt: string;
    articleId: string;
    body: string;
    title: string;
    titleDisabled: boolean;
    status: ArticleSectionStatus;
  }[];
}>({ sections: [] });

export default ArticleContext;
